import React from 'react'

// Company and university logos using actual brand assets from /logos/

export const TurnerLogo = ({ className }) => (
  <img
    src="/logos/Turner_Construction_logo.svg"
    alt="Turner Construction"
    className={className}
  />
)

export const DPRLogo = ({ className }) => (
  <img
    src="/logos/DPR_2010_logo_color_larger_3.1.16.png"
    alt="DPR Construction"
    className={className}
  />
)

export const MahindraLogo = ({ className }) => (
  <img
    src="/logos/Mahindra-Lifespaces.png"
    alt="Mahindra Lifespace Developers"
    className={className}
  />
)

export const VConstructLogo = ({ className }) => (
  <img
    src="/logos/VCONSTRUCT_PRIVATE_LIMITED.webp"
    alt="vConstruct"
    className={className}
  />
)

export const StanfordLogo = ({ className }) => (
  <img
    src="/logos/stanford.avif"
    alt="Stanford University"
    className={className}
  />
)

export const IITRoorkeeLogo = ({ className }) => (
  <img
    src="/logos/Indian_Institute_of_Technology_Roorkee_Logo.svg.png"
    alt="IIT Roorkee"
    className={className}
  />
)

export const NITBhopalLogo = ({ className }) => (
  <img
    src="/logos/Maulana_Azad_National_Institute_of_Technology_Logo.png"
    alt="NIT Bhopal (MANIT)"
    className={className}
  />
)
